import { Unplug, Settings } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import { useWorkspace } from "../../store/WorkspaceContext";

export const NoPlotterDialog = () => {
  const { state, dispatch } = useWorkspace();
  const open = state.dialog === "noPlotter";
  const live = state.bridge;
  const close = () => dispatch({ type: "SET", patch: { dialog: null } });
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="panel3d max-w-sm border-[#27324a] bg-[#121824] text-[#e8e9ec]" data-testid="no-plotter-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[15px]"><Unplug className="h-5 w-5 text-[#f5a524]" /> Please connect to a plotter</DialogTitle>
          <DialogDescription className="text-[#9aa0a8]">
            {live ? "No plotter is connected to your shop computer. Plug the plotter in via USB, turn it on, then press Cut again." : "Your shop computer is not connected. Start the Xpattern connector, plug the plotter in via USB and turn it on, then press Cut again."}
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <button data-testid="no-plotter-settings-btn" onClick={() => dispatch({ type: "SET", patch: { dialog: "settings" } })} className="btn flex-1"><Settings className="h-4 w-4" /> Plotter setup</button>
          <button data-testid="no-plotter-ok-btn" onClick={close} className="btn-red flex-1">OK</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
